import { motion } from "framer-motion";

const ease = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 1, delay, ease }}
  >
    {children}
  </motion.div>
);

const lineV = {
  hidden: { y: "110%" },
  show: (d) => ({ y: "0%", transition: { duration: 1.15, delay: d, ease } }),
};

export const MaskedLines = ({ lines, className = "", delay = 0, animateOnLoad = false, italicIndex = -1 }) => (
  <motion.span
    className={`block ${className}`}
    initial="hidden"
    {...(animateOnLoad ? { animate: "show" } : { whileInView: "show", viewport: { once: true, amount: 0.1 } })}
  >
    {lines.map((l, i) => (
      <span key={l + i} className="block overflow-hidden pb-[0.12em] -mb-[0.12em]">
        <motion.span className={`block ${i === italicIndex ? "italic text-gold-grad pr-[0.08em]" : ""}`} variants={lineV} custom={delay + i * 0.12}>
          {l}
        </motion.span>
      </span>
    ))}
  </motion.span>
);

export const SectionHead = ({ over, lines, sub, testid }) => (
  <div className="max-w-3xl" data-testid={testid}>
    <Reveal y={20}>
      <p className="eyebrow mb-6">{over}</p>
    </Reveal>
    <h2 className="font-display text-4xl sm:text-5xl lg:text-7xl font-light leading-[0.95] tracking-tight text-[#F9F9F9]">
      <MaskedLines lines={lines} italicIndex={1} />
    </h2>
    {sub && (
      <Reveal delay={0.2} y={20}>
        <p className="mt-8 max-w-xl text-base md:text-lg text-zinc-300 leading-relaxed">{sub}</p>
      </Reveal>
    )}
  </div>
);
